import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './index.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { App } from './App';
import { TooltipProvider } from './components/ui';
import { queryClient } from './lib/queries';
import { getLocale } from './lib/i18n';
import { publicPageLocales } from './marketing/catalog';
import { loadMarketingCopy } from './marketing/content';
import { splitLocalePath } from '@bannermatic/core';

// Public pages arrive pre-rendered; their texts are loaded before the first render so React
// shows the same page instead of a loader in between.
if (publicPageLocales(splitLocalePath(window.location.pathname).path)) {
  await loadMarketingCopy(getLocale()).catch(() => undefined);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <App />
        <Toaster
          position="bottom-right"
          richColors
          closeButton
          toastOptions={{ classNames: { title: 'whitespace-pre-line' } }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
